import { useEffect, useRef } from "react";

/**
 * Adds `.in-view` to `.reveal` elements when they enter the viewport.
 * Pass `deps` so the observer re-binds when async-loaded children appear.
 *
 *   const rootRef = useReveal([models.length]);
 */
export function useReveal(deps = []) {
  const rootRef = useRef(null);
  useEffect(() => {
    const root = rootRef.current || document;
    const els = root.querySelectorAll(".reveal:not(.in-view)");

    if (typeof IntersectionObserver === "undefined") {
      // SSR / very old browser fallback — just reveal everything.
      els.forEach((el) => el.classList.add("in-view"));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in-view");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -40px 0px" }
    );
    els.forEach((el) => io.observe(el));

    return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return rootRef;
}
